import { NotificacionesService } from './../../../services/notificaciones.service';
import { ChatService } from '../../../services/chat.service';
import { UserService } from '../../../services/user.service';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { AuthenticationService } from '../../../services/authentication.service';
import { TranslateService } from '@ngx-translate/core';
import { ColegiosService } from 'src/app/services/colegios.service';
import { NumeroalertasService } from 'src/app/admin/services/numeroalertas.service';
import { AlertasService } from 'src/app/services/alertas.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-hilo',
  templateUrl: './hilo.component.html',
  styleUrls: ['./hilo.component.css'],
})
export class HiloComponent implements OnInit, OnDestroy {
  mainUserId: string;
  searchValue = '';
  results: any;
  chatMessage = '';
  receiverId: string;
  chats = [];
  chatMessages = [];
  currentDate: Date;
  otherUserId: any;
  urlUid: string;
  /*nuevo */
  chatGroups = [];
  chatorimessa = [];
  chatUser: any;
  chatUsers = [];
  chatload = false;
  mainUserEmail: any;
  user: any;
  school: any;
  idSupervisor: any = '';
  notificationSubscription: any = null;
  storedMessages = [];
  aiChatFormat: any = {};
  last24hAlert = null;
  messagesRefreshInterval: any = null;

  constructor(
    private activatedRoute: ActivatedRoute,
    private notificationsService: NotificacionesService,
    private userService: UserService,
    private chatService: ChatService,
    private authenticationService: AuthenticationService,
    private translate: TranslateService,
    private schoolsService: ColegiosService,
    private _numeroAlertas: NumeroalertasService,
    private _alertService: AlertasService
  ) {}

  getUserRole(user: any): string {
    return user?.role || user?.role || '';
  }

  getUserName(user: any): string {
    return user?.name || user?.nombres || user?.firstName || user?.display_name || '';
  }

  getUserLastName(user: any): string {
    return user?.last_name || user?.apellidos || user?.apellido || user?.lastName || '';
  }

  getUserFullName(user: any, fallbackUserId: string = ''): string {
    const fullName = `${this.getUserName(user)} ${this.getUserLastName(user)}`.trim();
    return fullName || this.getUsername(user) || this.formatFallbackUser(fallbackUserId);
  }

  getUsername(user: any): string {
    return user?.username || user?.usuario || user?.email || user?.uid || '';
  }

  get selectedChatUser(): any {
    return this.chatUsers?.[this.otherUserId] || this.chatUser || null;
  }

  get mainChatUser(): any {
    return this.chatUsers?.[this.mainUserId] || this.user || null;
  }

  formatFallbackUser(userId: string): string {
    return userId ? `Usuario ${userId.slice(0, 8)}` : '';
  }

  private getSchoolIds(user: any): string[] {
    return user?.schools || [];
  }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe((params) => {
      this.urlUid = params['uid'];
      this.chatService.setChatActual(this.urlUid);
      const urlsplit = this.urlUid.split('|');
      if (urlsplit[0] === urlsplit[1]) {
        return;
      }
      this.authenticationService.getStatus().subscribe(
        (status) => {
          this.mainUserId = status.uid;
          this.mainUserEmail = status.email;
          if (urlsplit[0] != this.mainUserId) {
            this.otherUserId = urlsplit[0];
          } else {
            this.otherUserId = urlsplit[1];
          }
          if (this.otherUserId) {
            this.userService
              .getUserById(this.otherUserId)
              .subscribe((chatUser) => {
                if (!chatUser[0]) {
                  return;
                }

                this.chatUser = chatUser[0].payload.doc.data();
                const chatUserId = this.chatUser.uid || this.otherUserId;
                if (!this.chatUsers[chatUserId]) {
                  this.chatUsers[chatUserId] = this.chatUser;
                }
              });
            // let cortarObservable = true;
            this.notificationSubscription = this.notificationsService
              .getNotificacionesMensajesDeEmisor(
                this.mainUserId,
                this.otherUserId
              )
              .subscribe((messages) => {
                // if (cortarObservable) {
                // cortarObservable = false;
                console.log('messages hilo: ', messages);
                messages.forEach((messageItem) => {
                  let id = messageItem.payload.doc.id;
                  this.notificationsService.removeNotificacion(id).then();
                });
                // }
              });
          }

          let subscription = this.userService
            .getUserById(this.mainUserId)
            .subscribe((user) => {
              if (!user[0]) {
                return;
              }

              this.user = user[0].payload.doc.data();
              if (this.user?.uid) {
                this.chatUsers[this.user.uid] = this.user;
              }
              const schoolId = this.getSchoolIds(this.user)[0];
              if (!schoolId) {
                subscription.unsubscribe();
                return;
              }

              let schoolSubscription = this.schoolsService
                .getColegioByIdNow(schoolId)
                .subscribe((school) => {
                  if (!school?.exists) {
                    subscription.unsubscribe();
                    schoolSubscription.unsubscribe();
                    return;
                  }

                  this.school = school.data();

                  subscription.unsubscribe();

                  subscription.unsubscribe();
                  this.userService
                    .getSupervisor(school.id)
                    .subscribe((user) => {
                      if (!user.empty) {
                        var supervisorUser = user.docs[0].data();
                        this.idSupervisor = supervisorUser['uid'];
                      }
                      schoolSubscription.unsubscribe();
                    });

                  // this.userService.getUsersNow().subscribe((users) => {
                  //   users.forEach((user) => {
                  //     var supervisorUser = user.data();
                  //     if (
                  //       supervisorUser['schools'][0] == school.id &&
                  //       supervisorUser['rol'] == 'supervisor'
                  //     ) {
                  //       this.idSupervisor = supervisorUser['uid'];
                  //     }
                  //   });
                  //   schoolSubscription.unsubscribe();
                  // });
                });
            });
          //  this.findExistingAlert();
          this.loadMessages();
          this.startMessagesRefresh();
        },
        (error) => {
          console.log(error);
        }
      );
    });
  }
  ngOnDestroy(): void {
    if (this.notificationSubscription != null) {
      this.notificationSubscription.unsubscribe();
    }
    if (this.messagesRefreshInterval != null) {
      clearInterval(this.messagesRefreshInterval);
    }
  }

  findExistingAlert() {
    const members = {
      members: [
        { uid: this.mainUserId, join: true },
        { uid: this.otherUserId, join: true },
      ],
    };
    const ids = [this.mainUserId, this.otherUserId].sort();
    const chatId = ids.join('|');
    console.log('buscando alerta', chatId);
    this._alertService.getAlertaByIdChat(chatId).subscribe((alerts: any) => {
      // if (alerts.length > 0) {
      //   this.last24hAlert = alerts[0].payload.doc;
      // }
      if (alerts.length > 0) {
        const alertDoc = alerts[0].payload.doc;
        const alertData = alertDoc.data();
        const alertDate = alertData.alertDate.toDate(); // Convierte el timestamp a Date
        // // Calcula la diferencia en horas entre la date actual y la date de la alerta
        const now = new Date();
        const hoursDifference =
          (now.getTime() - alertDate.getTime()) / (1000 * 60 * 60); // Si la diferencia es menor a 12 horas, guarda la alerta en this.last24hAlert
        if (hoursDifference < 12) {
          this.last24hAlert = alertDoc;
        }
      }
    });
  }

  sendmessage() {
    let len = this.translate.getDefaultLang();

    if (this.chatMessage != '') {
      this.currentDate = new Date();
      const message = {
        sender_id: this.mainUserId,    // 
        receiver_id: this.otherUserId,  // 
        content: this.chatMessage,     // 
        // created_at has a server-side default — omit it
        // Keep the old fields locally for the analisis() / notification calls below:
        sender: this.mainUserId,       // kept for analisis() internal use only
        receiver: this.otherUserId,  // kept for notification url construction
        message: this.chatMessage,     // kept for analisis() text
        date: this.currentDate,            // kept for analisis() timestamp
      };
      this.chatMessage = '';
      const members = {
        members: [
          { uid: this.mainUserId, join: true },
          { uid: this.otherUserId, join: true },
        ],
      };
      const ids = [this.mainUserId, this.otherUserId].sort();
      const chatId = ids.join('|');
      this.chatService
        .sendmessage(chatId, message, members)
        .then((datames) => {
          this.chatMessage = '';
          this.loadMessages();
          this.analisis(message);

          var notification = {
            content: '🗨️ ' + message.message,
            sender_id: this.mainUserId,
            reciever_id: this.otherUserId,
            seen: false,
            event_id: null,
            message: true,
            url: '/dashboard/mensajes/chat/' + chatId,
            date: new Date(),
          };

          // switch (len) {
          //   case 'en':
          //     notification.texto = "You have received a new message"
          //     break;
          //   case 'es':
          //     notification.texto = "Has recibido un nuevo messageItem"
          //     break;

          //   default:
          //     break;
          // }

          // const notification = {
          //   user: this.otherUserId,
          //   texto: 'Ha recibido un nuevo messageItem',
          //   url: '/dashboard/mensajes/chat/' + chatId,
          //   verlo: this.otherUserId,
          //   date: new Date(),
          //   emisor: this.mainUserId
          // };
          this.notificationsService.createdNotificacion(notification);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }

  analisis(message) {
    let lowercaseMessage = message.message.toLowerCase();
    var requestData = {
      message: lowercaseMessage,
    };
    var jsonBody = JSON.stringify(requestData);
    const url = `${environment.cloudFunctionsApiUrl}/IABullying`;
    fetch(url, {
      method: 'POST',
      body: jsonBody,
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`IABullying failed with status ${response.status}`);
        }
        return response.text();
      })
      .then((data) => {
        if (data == 'true') {
          this._numeroAlertas.getNumber().subscribe((alerts) => {
            alerts.forEach((alertCounterDoc) => {
              var alertCounter: any = alertCounterDoc.data();

              var number: number = alertCounter.numero;
              this._numeroAlertas.editNumber();
              var alert = {
                schoolAvatar: this.school.avatar,
                status: 'pending',
                alertDate: message.date,
                alertId: number,
                schoolId: this.school.name,
                supervisorId: this.idSupervisor,
                userId: message.sender,
                message: message.message,
                showSupervisor: true,
                studentAvatar: this.user.avatar,
                reported: false,
                name: this.getUsername(this.user),
              };
              console.log('alert!', alert);

              this._alertService
                .createdAlerta(alert)
                .then(() => console.log('Alerta creada'));
            });
          });
        }
      })
      .catch((error) => {
        console.warn('No se pudo analizar el mensaje con IABullying', error);
      });
  }

  analisisChat(message) {
    const members = {
      members: [
        { uid: this.mainUserId, join: true },
        { uid: this.otherUserId, join: true },
      ],
    };
    const ids = [this.mainUserId, this.otherUserId].sort();
    const chatId = ids.join('|');

    const requestData = this.aiChatFormat;
    const jsonBody = JSON.stringify(requestData);
    const url = 'http://82.223.103.135/analyze-and-translate-chat';

    fetch(url, {
      method: 'POST',
      body: jsonBody,
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((data) => {
        console.log('dataapi', data);

        const total = data.total_messages;
        const toxicMessages = data.total_toxic_messages;

        let maxSeverity = '';
        if (total >= 3) {
          const percentage = (toxicMessages / total) * 100;
          if (percentage >= 75) {
            maxSeverity = 'alta';
          } else if (percentage >= 50) {
            maxSeverity = 'media';
          } else if (percentage >= 20) {
            maxSeverity = 'baja';
          }
        }

        if (maxSeverity) {
          let messageType = '';
          switch (maxSeverity) {
            case 'alta':
              messageType = '🚨 Amenaza crítica detectada';
              break;
            case 'media':
              messageType = '⚠️ Advertencia seria detectada';
              break;
            case 'baja':
            default:
              messageType = '🟡 Comportamiento inapropiado';
              break;
          }

          const alertMessage = `${messageType}: ${data.global_summary}`;

          if (this.last24hAlert != null) {
            const alert = {
              status: 'pending',
              alertDate: message.date,
              alertId: this.last24hAlert.data().alertId,
              chatId: this.last24hAlert.data().chatId,
              schoolId: this.last24hAlert.data().schoolId,
              supervisorId: this.last24hAlert.data().supervisorId,
              userId: this.last24hAlert.data().userId,
              message: alertMessage,
              showSupervisor: true,
              reported: true,
              name: this.last24hAlert.data().name,
              summary: data.global_summary,
              severity: maxSeverity,
            };
            this._alertService.editAlerta(this.last24hAlert.id, alert);
          } else {
            this._numeroAlertas.getNumber().subscribe((alerts) => {
              alerts.forEach((alertCounterDoc) => {
                const alertCounter: any = alertCounterDoc.data();
                const number: number = alertCounter.numero;
                this._numeroAlertas.editNumber();

                const newAlert = {
                  status: 'pending',
                  alertDate: message.date,
                  alertId: number,
                  chatId: chatId,
                  schoolId: this.school.name,
                  supervisorId: this.idSupervisor,
                  userId: message.sender,
                  message: alertMessage,
                  showSupervisor: true,
                  reported: true,
                  name: this.getUsername(this.user),
                  summary: data.global_summary,
                  severity: maxSeverity,
                };

                console.log(newAlert);
                this._alertService
                  .createdAlerta(newAlert)
                  .then(() => console.log('Alerta creada'));
              });
            });
          }
        }
      });
  }

  loadMessages() {
    this.chatService
      .getMessages(this.urlUid, this.mainUserId)
      .subscribe((messages) => {
        if (!messages || messages.length === 0) {
          this.chatGroups[this.urlUid] = [];
          this.storedMessages = [];
          this.chatload = true;
          return;
        }

        this.chatGroups[this.urlUid] = messages;
        this.storedMessages = messages;
        this.aiChatFormat = this.buildLast12hAiMessageFormat();

        messages.forEach((messageItem) => {
          const messageData = messageItem.payload.doc.data();
          const sender = messageData.sender_id || messageData.sender;
          const receiver = messageData.receiver_id || messageData.receiver;

          if (!sender || !receiver) {
            return;
          }

          if (this.mainUserId === sender) {
            this.otherUserId = receiver;
          } else if (this.mainUserId === receiver) {
            this.otherUserId = sender;
          }

          this.loadChatUser(sender);
          this.loadChatUser(receiver);
        });

        this.chatload = true;
      });
  }

  private startMessagesRefresh() {
    if (this.messagesRefreshInterval != null) {
      clearInterval(this.messagesRefreshInterval);
    }

    this.messagesRefreshInterval = setInterval(() => {
      this.loadMessages();
    }, 3000);
  }

  private loadChatUser(userId: string) {
    if (!userId || this.chatUsers[userId]) {
      return;
    }

    this.userService.getUserById(userId).subscribe((chatUser: any) => {
      const data = chatUser[0]?.payload.doc.data();
      if (data) {
        this.chatUsers[data.uid] = data;
      }
    });
  }

  scrolltobottom() {
    const objDiv = document.getElementById('themessagesbox');
    objDiv.scrollTop = objDiv.scrollHeight + 1000;
  }

  buildAiMessageFormat() {
    const format = {
      chat_id: this.urlUid,
      messages: [],
    };
    this.storedMessages.forEach((messageItem) => {
      var data = messageItem.payload.doc?.data();
      if (!data?.created_at) return;
      const date = data.created_at instanceof Date ? data.created_at : new Date(data.created_at);
      format.messages.push({
        sender: data.sender_id,
        content: data.content,
        timestamp: date,
      });
    });
    console.log('formato', format);
    return format;
  }
  buildLast12hAiMessageFormat() {
    const format = {
      chat_id: this.urlUid,
      messages: [],
    };

    const now: any = new Date();
    const twelveHoursMs = 12 * 60 * 60 * 1000;

    this.storedMessages.forEach((messageItem) => {
      var data = messageItem.payload.doc?.data();
      if (!data?.created_at) return;
      const date: any = data.created_at instanceof Date ? data.created_at : new Date(data.created_at);

      if (now - date <= twelveHoursMs) {
        format.messages.push({
          sender: data.sender_id,
          content: data.content,
          timestamp: date,
        });
      }
    });

    return format;
  }

  addMessageIA(message) {
    const milliseconds =
      message.date.seconds * 1000 + message.date.nanoseconds / 1000000;

    // Crear un nuevo objeto Date con los milliseconds
    const date = new Date(milliseconds);

    this.aiChatFormat.messages.push({
      sender: message.sender,
      content: message.message,
      timestamp: date,
    });
    return this.aiChatFormat;
  }
}

